import React from "react";

export default function NotFoundPage() {
    return (
        <>
            Strona nie znaleziona
        </>
    );
}